<template>
    <div v-if="ajaxFlag" class="container">
        <bg :bg="coupon.bg" :activity="coupon.activityBg"></bg>
        <return-btn></return-btn>
        <div :class="[!coupon.activityBg? 'wrap' : 're-wrap']">
            <div class="main">
                <div class="hbtop">
                    <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/hbtopimg.2017102301.png" class="hbtop-img" alt="">
                    <div class="inner">
                        <div class="welcome">
                            <p>{{coupon.tit}}</p>
                            <p class="welcome-tit">{{coupon.con}}</p>
                        </div>
                    </div>
                    <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/side.2017102301.png" class="hbw" alt="">
                </div>
                <div class="hbbottom">
                    <div class="hb-location">
                        <span class="hb-location-l">所在城市：
                            <span class="hb-loc-red" v-if="getCity">{{getCity}}</span>
                            <p v-else>定位中...</p>
                        </span>
                        <span class="hb-location-r hb-loc-red" @click="edit">修改 ></span>
                    </div>
                    <form action="" class="form">
                        <p class="nologin" v-if="isLogin && !isAppFlag">
                            <input maxlength="11" placeholder="请输入11位手机号" v-model="local.phone" type="tel" class="inp tel" autocomplete="off" @keyup="formVali(local.phone)" @blur="formVali(local.phone)" />
                            <input maxlength="4" placeholder="请输入验证码" v-model="verif" type="tel" class="inp verif" autocomplete="off" @keyup="formVali(verif)" @blur="formVali(verif)" />
                            <span class="line"></span>
                            <span class="getverif" :class="{'disabled': !isVerifCode}" v-if="isVerif" @click="getVerif">获取验证码</span>
                            <span class="cutdown" v-else>{{cutdown}}s</span>
                        </p>
                        <p class="login" v-else>
                            <input maxlength="11" placeholder="请输入11位手机号" v-model="local.phone" type="tel" class="inp s1-1-4" autocomplete="off" @keyup="formVali(local.phone)" @blur="formVali(local.phone)" />
                        </p>
                        <p>
                            <input type="button" class="btn disabled" value="立即领券" v-if="disabledFlag" />
                            <input type="button" class="btn" value="立即领券" @click="submitEvent" v-if="!disabledFlag" />
                        </p>
                    </form>
                    <ul class="list">
                        <!-- <rule :rule="coupon.rule"></rule> -->
                        <li class="ruleCity" @click="showRuleEvent">{{coupon.rule.tit}}</li>
                        <li class="application app2" @click="showAboutEvent" v-if="coupon.introFlag">{{coupon.introtit}}</li>
                        <!-- <about :intro="coupon.intro" v-if="coupon.introFlag"></about> -->
                    </ul>
                </div>
            </div>
        </div>
        <div class="coupon_blank">
            <img :src="coupon.activityBg" alt="" />
        </div>
        <download :info="downloadInfo" v-if="downloadInfo.flag"></download>
        <!-- <btn :download="coupon.downloadFlag" :download-info="coupon.downloadInfo"></btn> -->
        <rule :rule="coupon.rule" v-if="ruleFlag"></rule>
        <about :intro="coupon.intro" :introtit="coupon.introtit" v-if="aboutFlag"></about>
    </div>
    <div class="toast" v-show="tipFlagToast">
        <p>{{textTip}}</p>
    </div>
    <loading v-if="loading"></loading>
    <!-- <alert :show.sync="popFlag" :city="getGeoCity" :cancel-show="false" @on-confirm="onConfirm">
                <dl class="alertTxt">
                    <dt>您当前的定位城市为</dt>
                    <dd>
                        <span>{{getGeoCity}}</span>
                        <span @click="edit">修改 ></span>
                    </dd>
                </dl>
            </alert> -->
    <!-- <div class="twoalert">
                <alert :show.sync="popChangeFlag" :city="getGeoCity" confirm-text="切换" @on-confirm="qCity">系统定位到您在{{getGeoCity}}，是否切换城市</alert>
            </div> -->
    <alert :show.sync="popTipFlag" :confirm-show="false" cancel-text="我知道了">亲，{{getCity}}暂未开始此活动~请持续关注哦~'</alert>
    </div>
</template>
<script>
import Loading from './base/Loading.vue';
// import Btn from './base/Btn.vue';
import Rule from './base/Rule.vue';
import About from './base/About.vue';
import Bg from './base/Bg.vue';
import ReturnBtn from './base/ReturnBtn.vue';
import Alert from './base/Alert.vue';
import storageSupport from '../tools/storageSupport.js'
import Download from './base/Download.vue'
import {trackAction, trackPageviewObject} from '@/tools/track.js'
import utils from '@/tools/utils.js'

import {
    mapGetters
} from 'vuex'

var trackParamBasic = {
  'page_type': 'bjhongbao_coupon',
  'pagename': 'bjhongbao_coupon_bind',
  'templateid': utils.urlParam('templateid')
}
export default {
    computed: mapGetters([
        'getGeoCity',
        'getCityList',
        'getCity',
        // 'getFlag',
        'getOneFlag',
        'getResult'
    ]),
    props: {
        pagedata: Object
    },
    data() {
        //默认背景
        // https://images.daojia.com/dop2c/djlian/563c3933c867ae482ec431e6f22270f3.jpeg
        var bg = '//images.daojia.com/jz/pic/c98147efea407f45a99035ba59013aae.png';
        //标题
        var tit = '诚邀您体验';
        //副标题
        var con = '天鹅到家生活服务';
        // var reg = /^daojia:.+/.test(window.downloadUrl)
        // if (window.isAppFlag && !reg) {
        //     window.downloadUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(window.downloadUrl);
        // }
        return {
            // popFlag: false,
            // popChangeFlag: false,
            popTipFlag: false,
            bid: this.$route.query.bid,
            activityId: this.$route.query.activityid,
            templateId: this.$route.query.templateid,
            taskid: this.$route.query.taskid,
            actTitle: '',
            local: {
                phone: '',
                cityDefault: '',
                cityid: ''
            },
            verif: '',
            errorFlag: false,
            loading: false,
            ruleFlag: false,
            aboutFlag: false,
            ajaxFlag: false,
            disabledFlag: true,
            maskFlag: false,
            cutdown: 60,
            isLogin: false,
            isVerif: true,
            isVerifCode: false,
            textTip: '',
            tipFlagToast: false,
            isAppFlag: Boolean(window.isAppFlag),
            downloadInfo: {
                logo: 'https://images.daojia.com/jz/pic/97e3b19805fee9f57e4bed2b8dd76d64.png',
                content: '天鹅到家\r\n专业便捷安心的上门服务平台',
                url: window.downloadUrl,
                flag: false
            },
            coupon: {
                tit: tit,
                con: con,
                bg: bg,
                activityBg: window.activityBg,
                rule: window.rule,
                intro: window.intro,
                introtit: window.introtit,
                introFlag: false,
                introHeader: window.introtit,
                fzbtoken: '',
                shareFlag: false
            }
        }
    },
    created() {
        var that = this
        // h5 多次点城市 领券页返回按钮只有一次历史记录
        // if (!window.isAppFlag && this.getOneFlag) {
        //     window.history.go(-1)
        //     this.$store.dispatch('resetOneFlag')
        // }
        // 埋点
        trackPageviewObject(trackParamBasic)
        // app导航 隐藏右侧按钮
        window.setRightButtons(window.rightButtonsHide)
        window.Back.reset();
        window.Back.push(function() {
            window.location.href = 'daojia://finish';
        });

        // 渲染页面
        that.fetchData()
        // 回填手机号逻辑
        that.getPhone()
        // 城市列表
        this.$store.dispatch('cityList', {
            'activityid': that.activityId,
            'templateid': that.templateId
        })
        // 其他页面返回到此页面时 有城市则回填 否则 走获取城市逻辑
        // if (this.getCity) {
        //     if (!that.getGeoCity) {
        //         that.getCityGeo(that.getCity)
        //     } else {
        //         that.showAlert(that.getCity)
        //     }
        // } else { // 获取默认城市
        //     that.getCityDefault()
        // }
        that.getCityDefault()
        // 判断环境
        if (that.isApp()) {
            that.isAppFlag = true
        }else{
            that.isAppFlag = false
        }
        console.log(location.href)
    },
    // 移除body背景色
    ready() {
        var that = this;
        document.body.removeAttribute('style');
    },
    events: {
        ruleFlagEvent() {
            var that = this;
            that.ruleFlag = false;
        },
        aboutFlagEvent() {
            var that = this;
            that.aboutFlag = false;
        }
    },
    methods: {
        // 判断App环境
        isApp(){
            var ret = false;
            var userAgent = navigator.userAgent;
            var ua = userAgent.toLowerCase();
            var cookiestr = document.cookie;
            if (userAgent.indexOf('cdvsupport') >= 0 || cookiestr.indexOf('cdvsupport') >= 0 || ua.indexOf("daojia") != -1 || ua.indexOf("58app") != -1) {
                ret = true;
            }
            return ret;
        },
        // 获取验证码
        getVerif(){
            var that = this;
            if (that.isVerifCode) {  // 是否可以获取验证码
                that.isVerif = false
                that.$http.jsonp(window.getCodeUrl, {
                    params: {
                        'mobile': that.local.phone
                    }
                }).then(function(res) {
                    var data = Object.assign({}, res.json())
                    if (data.code == 0) {
                    } else {
                        that.tipFlagToast = true;
                        that.textTip = data.desc;
                        setTimeout(function(){
                            that.tipFlagToast = false;
                        },3000)
                    }
                }, function(err) {
                    that.tipFlagToast = true;
                    that.textTip = err;
                    setTimeout(function(){
                        that.tipFlagToast = false;
                    },3000)
                })
                that.setTime()
            }

        },
        // 倒计时
        setTime() {
            var that = this;
            if (this.cutdown == 0) {
                this.isVerif = true
                this.cutdown = 60
                clearTimeout(window.timeout)
            } else {
                this.cutdown--;
                window.timeout = setTimeout(function() {
                    that.setTime()
                }, 1000)
            }
        },
        // 活动规则遮罩显示
        showRuleEvent() {
            var that = this;
            that.ruleFlag = true;
        },
        // 关于我们遮罩显示
        showAboutEvent() {
          var that = this;
          that.aboutFlag = true;
        },
        // 获取手机号
        getPhone() {
            var that = this
            var query = that.$route.query
                // url有手机号 默认手机号 = url手机号
                // 否则 localStorage有手机号 默认手机号=localStorage手机号
            if (query.phone) {
                if (that.phoneValidate(query.phone)) {
                    that.local.phone = query.phone
                } else {
                    that.getPhoneLocal()
                }
            } else {
                that.getPhoneLocal()
            }
        },
        // 获取本地手机号
        getPhoneLocal() {
            var that = this
            if (storageSupport) {
                var phone = localStorage.getItem('COUPON_STORAGE_PHONE')
                if (phone) {
                    if (that.phoneValidate(phone)) {
                        that.local.phone = phone
                    }
                }
            }
        },
        // 手机号验证
        phoneValidate(phone) {
            var that = this;
            var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
            if (reg.test(phone)) {
                return true;
            } else {
                return false;
            }
        },
        // 验证码验证
        verifValidate(verif){
            var that = this;
            var reg = /^\d{4}$/;
            that.verif = that.verif.replace(/[^\d]/g, '')
            if (reg.test(verif)) {
                return true
            } else {
                return false
            }
        },
        // 表单整体验证，控制按钮是否可点击
        formVali(){
            var that = this;
            if (that.isLogin && !isAppFlag) {
                // 是h5环境且需要登录
                if (that.phoneValidate(that.local.phone)) {  // 验证手机号是否合法，控制获取验证码可点击
                    that.isVerifCode = true
                }else{
                    that.isVerifCode = false
                }
                if (that.verifValidate(that.verif) && that.phoneValidate(that.local.phone)) {  // 验证手机号和验证码是否合法，控制按钮可点击
                    that.disabledFlag = false
                } else {
                    that.disabledFlag = true
                }
            }else{
                //是h5环境且不需要登录
                if (that.phoneValidate(that.local.phone)){  // 验证手机号是否合法，控制按钮可点击
                    that.disabledFlag = false
                } else {
                    that.disabledFlag = true
                }
            }
        },
        // 获取城市
        getCityDefault() {
            var that = this
            var query = that.$route.query
            var city = '',cityname;
            if (query.isback) {
                // 城市列表页返回的
                var query = getUrlParam();
                var origin = window.location.origin || (window.location.protocol + '//' + window.location.host)
                var path = window.location.pathname;
                var host = window.location.host;
                that.local.cityDefault = getCookieByDecode('dj_cityname')
                window.shareAppData.shareUrl = origin + path + '?activityid=' + query.activityid + '&templateid=' + query.templateid + '&bid=' + query.bid + '&cityname=' + that.local.cityDefault;
                this.$store.dispatch('city', that.local.cityDefault)
            }else{
                //先从cookie中取值
                var citynameCookie = getCookieByDecode('dj_cityname');
                 var citynameLS = localStorage.getItem('COUPON_STORAGE_CITYNAME');
                 if (citynameCookie) {
                     that.local.cityDefault = citynameCookie;
                     this.$store.dispatch('city', that.local.cityDefault)
                 } else if (citynameLS) {
                     that.local.cityDefault = decodeURIComponent(citynameLS)
                     this.$store.dispatch('city', that.local.cityDefault)
                 } else {
                   djLocation.getCurrentLocation({
                    timeout: 30 * 1000
                  }, (data) => {
                    that.local.cityDefault = data.cityName
                    this.$store.dispatch('city', that.local.cityDefault)
                  }, () => {
                    var currUrl = location.href.split('#!')[0] + '&isback=true';
                    var backUrl = window.djlocationUrl + '?businessId=105&activityid=' + that.activityId + '&templateId=' + that.templateI + '&taskid=' + that.taskid + '&backUrl=' + encodeURIComponent(currUrl);
                    location.replace(backUrl);
                  })
                }
            }
            // this.$store.dispatch('city', that.local.cityDefault)
            // 自动定位
            // that.getCityGeo(that.local.cityDefault)
        },
        // 判断登录
        needLogin(){
            var that = this
            if (isAppFlag) {  //是否是app环境
                if (DjUser.getUserInfo() == null) {  //是否已经登录
                    that.isLogin = true
                    DjUser.login4callback(function(result){
                        if (result.code == 0) {
                            that.isLogin = false
                        }
                    }, function(result){
                        that.isLogin = true
                    }, 101)
                }else{
                    that.isLogin = false
                }
            }else{
                that.isLogin = true
            }
        },

         // 渲染领券页面
        fetchData() {
            var that = this;
            that.loading = true;
            // that.$http.get(window.couponUrl, {
            that.$http.jsonp(window.couponUrl, {
                params: {
                    'activityid': that.activityId,
                    'templateid': that.templateId
                }
            }).then(function(res) {
                that.ajaxFlag = true;
                that.loading = false;
                var data = Object.assign({}, res.json())
                if (data.code == 0) {
                    var data = data.data;
                    if (data) {
                        if (data.needLogin) {
                            that.needLogin()
                        }
                        if (data.activityTitle) {
                            document.title = data.activityTitle;
                        }
                        if (data.activityInfoBackground) {
                            that.coupon.activityBg = data.activityInfoBackground
                            window.activityInfoBackground = that.coupon.activityBg
                        }
                        if (data.releaseCouponBackgroud) {
                            that.coupon.bg = data.releaseCouponBackgroud
                            that.coupon.activityBg = data.activityInfoBackground
                            window.activityInfoBackground = that.coupon.activityBg
                            window.resultCouponBackgroud = that.coupon.bg
                            if(storageSupport){
                                sessionStorage.setItem('resultCouponBackgroud', that.coupon.bg)
                            }
                        }
                        if (data.releaseCouponTitle) {
                            that.coupon.tit = data.releaseCouponTitle;
                        }
                        if (data.releaseCouponContent) {
                            that.coupon.con = data.releaseCouponContent;
                        }
                        if (data.rule && data.rule.ruleTitle) {
                            that.coupon.rule.tit = data.rule.ruleTitle;
                        }
                        if (data.rule && data.rule.ruleContent) {
                            that.coupon.rule.con = data.rule.ruleContent;
                        }
                        if (data.introduce && data.introduce.content) {
                            that.coupon.intro = data.introduce.content;
                        }
                        if (data.introduce && data.introduce.title) {
                            that.coupon.introtit = data.introduce.title;
                        }
                        if (data.introduce && data.introduce.introduceHeader) {
                            that.coupon.introHeader = data.introduce.introduceHeader;
                        }
                        if (parseInt(data.introduce.type) == 0) {
                            that.coupon.introFlag = true;
                        }
                        if (parseInt(data.downloadNeed) == 0) {
                            window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                        } else if (parseInt(data.downloadNeed) == 1) {
                            window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                        }
                        if (data.download) {
                            if (parseInt(data.download.downloadNeed) == 0) {
                                // 默认天鹅到家
                                window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                            } else if (parseInt(data.download.downloadNeed) == 1) {
                                // 不需要
                                that.downloadInfo.flag = false
                            } else if (parseInt(data.download.downloadNeed) == 2) {
                                // 自主配置
                                console.log(window.isAppFlag)
                                that.downloadInfo.flag = true
                                // window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                                that.downloadInfo.content = data.download.downloadButtonContent
                                that.downloadInfo.url = data.download.downloadButtonUrl
                                that.downloadInfo.logo = data.download.downloadButtonLogo
                                // var reg = /^daojia:.+/.test(that.downloadInfo.url)
                                // if (window.isAppFlag && !reg) {
                                //     let btnUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(that.downloadInfo.url);
                                    // this.$store.dispatch('setDownloadUrl',btnUrl)
                                    // that.downloadInfo.url = btnUrl
                                // }
                            }
                        }
                        if (data.share && parseInt(data.share.type) == 0) { //配置分享
                            console.log('配置分享了')
                            var share = data.share;
                            window.setRightButtons(window.rightButtons);
                            var shareimg = share.imgUrl ? share.imgUrl : window.shareAppData.iconUrl;
                            var sharetit = share.title ? share.title : window.shareAppData.title;
                            var sharecon = share.content ? share.content : window.shareAppData.content;
                            window.shareEvent(shareimg, sharetit, sharecon);
                            if (share.imgUrl) {
                                window.shareAppData.iconUrl = share.imgUrl
                            }
                            if (share.title) {
                                window.shareAppData.title = share.title
                            }
                            if (share.content) {
                                window.shareAppData.content = share.content
                            }
                        } else if (data.share && parseInt(data.share.type) == 1) { //禁用分享
                            that.shareDefault();
                        }
                        if (data.fzbtoken) {
                            that.coupon.fzbtoken = data.fzbtoken;
                        }
                        if (data.actTitle) {
                            that.actTitle = data.actTitle
                        }
                        //微信分享赋值
                        that.wxShareVal(window.shareAppData.title,window.shareAppData.iconUrl);

                        // 埋点 领券页
                        var tokenid = that.coupon.fzbtoken;
                        window.bi_params = {
                            activityid: that.activityId,
                            actTitle: that.actTitle,
                            pagetype: 'bindcoupon',
                            token_id: tokenid,
                            load_anti_cheat: 'true'
                        };
                        that.formVali()
                    } else {
                        // that.trackEvent();
                        that.shareDefault();
                        that.formVali()
                    }
                } else {
                    // that.trackEvent();
                    that.shareDefault();
                    that.formVali()
                }
            }, function() {
                // that.trackEvent();
                that.loading = false;
                that.ajaxFlag = true;
                var router = that.$route.router;
                router.go({
                    name: 'error'
                });
            })

        },
        shareDefault() {
            var that = this;
            window.shareHide();
            window.setRightButtons(window.rightButtonsHide);
        },
        // 点击按钮
        submitEvent() {
            // 百度回传
            if(utils.urlParam("hmsr")==="baidu_feed"&&utils.urlParam("baidu_convert_id")){
                window._agl&&window._agl.push(['track',['success',{t:3}]])
            }
            var that = this
            Object.assign(trackParamBasic, {
              'event_id': 'click_bind_coupon'
            })
            trackAction(trackParamBasic)
            if (that.isLogin && isAppFlag){
                // app 没有登录的情况
                that.needLogin();
            }else{
                // app 登录的情况
                if (that.isLogin){
                    // 需要登录
                    that.login()
                } else {
                    // 不需要登录
                    that.loading = true
                    // 校验用户的城市是否在券城市集合中
                    that.getCityIdFunc()
                    // 更新本地存储城市、手机号
                    this.$store.dispatch('city', that.getCity)
                    if (storageSupport) {
                        localStorage.setItem('COUPON_STORAGE_CITYNAME', that.getCity)
                        localStorage.setItem('COUPON_STORAGE_PHONE', that.local.phone)
                    }
                }
            }
        },
        // 登录
        login() {
            var that = this;
            that.$http.jsonp(window.loginUrl, {
                params: {
                    'mobile': that.local.phone,
                    'code': that.verif
                }
            }).then(function(res) {
                var data = Object.assign({}, res.json())
                if (data.code == 0) {
                    that.loading = true
                    // 校验用户的城市是否在券城市集合中
                    that.getCityIdFunc()
                    // 更新本地存储城市、手机号
                    this.$store.dispatch('city', that.getCity)
                    if (storageSupport) {
                        localStorage.setItem('COUPON_STORAGE_CITYNAME', that.getCity)
                        localStorage.setItem('COUPON_STORAGE_PHONE', that.local.phone)
                    }
                } else {
                    that.tipFlagToast = true;
                    that.textTip = data.desc;
                    setTimeout(function(){
                        that.tipFlagToast = false;
                    },3000)
                }
            }, function(err) {
                that.tipFlagToast = true;
                that.textTip = data.desc;
                setTimeout(function(){
                    that.tipFlagToast = false;
                },3000)
                that.textTip = JSON.stringify(err);
            })
        },
        // 校验用户的城市是否在券城市集合中
        getCityIdFunc() {
            var that = this
                // 根据name寻找id
            for (var i = 0; i < that.getCityList.length; i++) {
                if (that.getCityList[i].cityName == that.getCity) {
                    that.local.cityid = that.getCityList[i].cityId;
                    break;
                }
            }
            if (that.activityId && that.templateId && that.getCity && that.local.phone && that.coupon.fzbtoken) {
                // 城市在券集合中 提交ajax 否则 弹框提示
                if (that.local.cityid) {
                    that.submitAjax()
                } else {
                    that.loading = false;
                    that.ajaxFlag = true;
                    that.popTipFlag = true
                }
            } else { // 如果参数不全 跳到结果页 提示网络异常
                that.go();
            }
        },
        // 提交ajax
        submitAjax() {
            var that = this
            var _params = {
                'activityid': that.activityId,
                'templateid': that.templateId,
                'cityid': that.local.cityid,
                'phone': that.local.phone,
                'fzbtoken': that.coupon.fzbtoken,
                'taskid': that.taskid
            };
            var query = this.$route.query
            if(query.appid) {
                _params.appid = query.appid
            }
            if(query.znsr) {
                _params.source = query.znsr
            } else if(query.hmsr) {
                _params.source = query.hmsr
            }
            if (that.bid) {
                _params.bid = that.bid
            }
            // that.$http.get(window.resultUrl, {
            that.$http.jsonp(window.resultUrl, {
                params: _params
            }).then(function(res) {
                var data = Object.assign({}, res.json())
                that.loading = false;
                that.ajaxFlag = true;
                // 埋点 领券成功页
                if (data.code == 0) {
                    var type = parseInt(data.data.type);
                    if (type == 0) {
                        var batchId = [];
                        var couponCodes = [];
                        for (var i = 0; i < data.data.couponList.length; i++) {
                            couponCodes.push(data.data.couponList[i].couponCodes);
                            batchId.push(data.data.couponList[i].batchId)
                        }
                        window.bi_params = {
                            activityid: that.activityId,
                            actTitle: that.actTitle,
                            batch_id: batchId.join(),
                            coupon_code: couponCodes.join(),
                            pagetype: 'bindsuccess',
                            uid: data.data.uid,
                            mobile: data.data.phone,
                            city_id: that.local.cityid
                        };
                    }
                }
                // 跳转
                window.ActivityResultData = data
                if(storageSupport){
                    sessionStorage.setItem('ActivityResultData', JSON.stringify(data))
                }
                that.go();
            }, function() {
                window.ActivityResultData = ''
                if(storageSupport){
                  localStorage.setItem('ActivityResultData', '')
                }
                that.loading = false;
                that.ajaxFlag = true;
                var router = that.$route.router;
                router.go({
                    name: 'error'
                });
            })
        },
        // 去结果页
        go() {
            var that = this;
            var router = that.$route.router;
            router.go({
                name: 'result'
            })
        },
        // 修改
        edit() {
            var that = this
            var router = that.$route.router;
            var currUrl = location.href.split('#!')[0] + '&isback=true';
            //todo 处理多次点击
            var backUrl = window.djlocationUrl + '?businessId=105&activityid=' + that.activityId + '&templateId=' + that.templateI + '&taskid=' + that.taskid + '&backUrl=' + encodeURIComponent(currUrl);

            // if (that.isApp()) {
            //     location.href = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(backUrl)
            // } else {
            //     location.replace(backUrl)
            // }
            location.replace(backUrl);
            // if (this.getOneFlag) {
            //     router.replace({
            //         name: 'city'
            //     })
            // } else {
            //     router.go({
            //         name: 'city'
            //     })
            // }
        },
        wxShareVal(sharetit,shareimg){
            //如果为微信小程序，将分享的标题、图片及跳转链接传给微信小程序
            if (typeof wx == 'object'){
                wx.miniProgram.getEnv(function(res) {
                    if (res.miniprogram){   // 小程序环境
                        wx.miniProgram.postMessage({
                            data: {
                                shareTitle : sharetit,
                                shareImg: shareimg,
                                shareUrl: window.shareAppData.shareUrl
                            }
                        })
                    }
                })
            }
        }
    },
    components: {
        Loading,
        // Btn,
        Rule,
        About,
        Bg,
        Alert,
        Download,
        ReturnBtn
    }
}
</script>
<style>
.container {
    position: relative;
}
.hb-location {
    text-align: left;
    overflow: hidden;
    margin: 0 0 1rem;
}

.hb-location-l {
    float: left;
    font-size: 1.2rem;
}

.hb-location-r {
    float: right;
}

.hb-loc-red {
    color: #f74951;
    font-size: 1.2rem;
}

.alertTxt {
    text-align: left;
}

.alertTxt dt {
    font-size: 13px;
    margin: 0 0 15px;
}

.alertTxt dd {
    overflow: hidden;
}

.alertTxt dd span:first-of-type {
    float: left;
}

.alertTxt dd span:last-of-type {
    float: right;
}

.coupon_blank{
    position: relative;
    /* margin-top: 40px; */
    z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// Coupon.vue?bfe8c03e